import V2Card from '../V2Card';
import '../App.css';

function CampaignMenu({
    campaign,
    tab,
    setTab,
}) {
    function getMenuItems() {
        // TODO: fix this security privacy
        if (localStorage.getItem('user_id') != campaign.owner_id) {
            return [
                {
                    title: 'Preview',
                    link: '/campaign/',
                },
            ]
        }

        return [
            {
                title: 'Screens',
                link: '/campaign/devices/',
                active: true,
            },
            {
                title: 'Settings',
                link: '/campaign/settings/',
                active: true,
            },
            {
                title: 'Statistics',
                link: '/campaign/stats/',
                active: true,
            },
            {
                title: 'Preview',
                link: '/campaign/',
                active: true,
            },
            {
                title: 'Budget',
                link: '/campaign/budget/',
                active: false,
            },
            {
                title: 'Promote',
                link: '/campaign/budget/',
                active: false,
            },
        ]
    }

    const menuItems = getMenuItems();

    const divMenuItems = menuItems.map(
        m =>
            <div
                style={{
                    cursor: 'pointer',
                    marginLeft: '2em',
                    color: !m.active ? 'grey' : null,
                }}
                onClick={
                    () => {
                        if (!m.active) {
                            return;
                        }
                        setTab(m.link);
                    }
                }
            >
                <b>
                    {
                        tab == m.link &&
                        <div className='sub-menu-item-selected'>
                            {m.title}
                        </div>
                    }
                    {
                        tab != m.link &&
                        <div className='sub-menu-item'>
                            {m.title}
                        </div>
                    }
                </b>
            </div>
    )
    console.log("TAB", tab);

    return (
        <V2Card>
            <div
                align='left'
                style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}
            >
                {divMenuItems}
            </div>
        </V2Card>
    );
}

export default CampaignMenu;